import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui } from "@ryde/theme";

export const HUB_STATION_TEMPLATE_E2E = "hub-station-template";

export const HubStationTemplateStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: HUB_STATION_TEMPLATE_E2E,
})`
  & .hub-station-field {
    position: relative;
  }

  & .hub-station-info-button {
    position: absolute;
    top: 50%;
    inset-inline-start: 100%;
    margin-inline-start: 14px;
    transform: translateY(-50%);
    color: ${greyMui._400};
    padding: 4px;

    &:hover {
      color: ${greyMui._500};
      background: transparent;
    }
  }

  & .hub-station-loading {
    display: block;
    min-height: 1px;
  }

  & .no-hub-message {
    display: inline-flex;
    align-items: center;
    width: fit-content;
    max-width: 100%;
    margin: 4px 0;
    padding: 4px 10px;
    border-radius: 10px;
    font-size: 12px;
    line-height: 1.2;
    background: rgba(109, 109, 109, 0.12);
    color: ${greyMui._600};
  }
`;
